import React from 'react';
import Select from 'react-select';
import { Controller, Control } from 'react-hook-form';
import { IOption } from '../../../../types/options';
import styles from '../styled-select.module.scss';
import {
  styleBase,
  styleBold,
} from '../style';

interface SelectProps {
  name: string,
  control: Control<any>,
  options: IOption[],
  rules?: any,
  widthLabel?: string | null,
  inline?: boolean,
  placeholder?: string,
  isMulti?: boolean,
  label?: string | null,
  className?: string,
  isClearable?: boolean,
  isSearchable?: boolean,
  isDisabled?: boolean,
  defaultValue?: any,
  handleChange?: (val: any) => void,
  prop?: any,
}

const StyledSelect = ({
  name,
  control,
  rules,
  options,
  widthLabel = null,
  inline = false,
  placeholder = '',
  label = null,
  className,
  isClearable = false,
  isSearchable = false,
  defaultValue,
  handleChange,
  ...props
}: SelectProps) => {
  function getClassName() {
    let style;
    if (className === 'bold') style = styleBold;
    else style = styleBase;
    return style;
  }
  return (
    <Controller
      name={name}
      control={control}
      rules={rules}
      defaultValue={defaultValue}
      render={({
        field,
      }) => (
        <div className={inline ? `${styles['container-select']} ${styles.inline}` : `${styles['container-select']}`}>
          {label && <label style={widthLabel ? { minWidth: widthLabel } : {}}>
            {label}
            {rules && (<sup>*</sup>)}
          </label>}
          <Select
            {...field}
            {...props}
            value={field.value
              ? options.find((option: IOption) => option.value === field.value)
              : null}
            options={options}
            onChange={(opt: IOption) => {
              field.onChange(props.isMulti ? opt : opt?.value);
              if (handleChange) handleChange(opt);
            }}
            defaultValue={defaultValue}
            isClearable={isClearable}
            isSearchable={isSearchable}
            className={`${styles.select}`}
            placeholder={placeholder}
            styles={getClassName()}
          />
        </div>
      )}
    />
  );
};

export default StyledSelect;
